/**
 * Phase 66 Plan 02 — Breadcrumb derived from route handle metadata.
 *
 * Reads `useMatches()` from react-router and renders `match.handle.breadcrumb`
 * for each level. `handle.breadcrumb` may be a string OR a function
 * `(params) => string` for dynamic segments (e.g., `/machines/:cpuId`).
 *
 * @see PATTERNS.md §Layout chrome — `<Breadcrumb>` (was Phase 65 empty slot)
 */

import { Link, useMatches } from "react-router";

type CrumbHandle = {
  breadcrumb?: string | ((params: Record<string, string | undefined>) => string);
};

export default function Breadcrumb() {
  const matches = useMatches();
  const crumbs = matches
    .filter((m) => (m.handle as CrumbHandle | undefined)?.breadcrumb !== undefined)
    .map((m) => {
      const handle = m.handle as CrumbHandle;
      const label =
        typeof handle.breadcrumb === "function"
          ? handle.breadcrumb(m.params as Record<string, string | undefined>)
          : (handle.breadcrumb as string);
      return { to: m.pathname, label };
    });

  return (
    <nav
      className="breadcrumb"
      id="breadcrumb"
      data-testid="breadcrumb"
      aria-label="Breadcrumb"
    >
      {crumbs.map((c, i) => (
        <span key={c.to}>
          {i > 0 ? <span className="breadcrumb-sep"> / </span> : null}
          <Link to={c.to} className="text-text-muted hover:text-text">
            {c.label}
          </Link>
        </span>
      ))}
    </nav>
  );
}
